export const CRM_LIST = [
  {
    id: "fub",
    name: "Follow Up Boss",
    short: "FUB",
    iconBg: "bg-primary",
    description:
      "Automatically sync buyers and property search criteria with Follow Up Boss.",
    status: "available",
  },
  {
    id: "lofty",
    name: "Lofty",
    short: "LO",
    iconBg: "bg-blue-500",
    description:
      "Sync leads, contacts, and listings from Lofty (formerly Chime) directly into FyrstUp.",
    status: "coming",
  },
  {
    id: "sierra",
    name: "Sierra Interactive",
    short: "SI",
    iconBg: "bg-orange-500",
    description:
      "Connect your Sierra Interactive account to sync buyer searches and activity.",
    status: "coming",
  },
  {
    id: "boomtown",
    name: "BoomTown",
    short: "BT",
    iconBg: "bg-rose-500",
    description:
      "Bring BoomTown leads and saved searches into FyrstUp for automated buyer matching.",
    status: "coming",
  },
  {
    id: "kvcore",
    name: "kvCORE",
    short: "kv",
    iconBg: "bg-purple-500",
    description:
      "Sync kvCORE contacts, smart numbers, and search criteria with FyrstUp listings.",
    status: "coming",
  },
  {
    id: "hubspot",
    name: "HubSpot",
    short: "HS",
    iconBg: "bg-pink-400",
    description:
      "Connect HubSpot CRM to sync real estate contacts and pipeline activity.",
    status: "coming",
  },
  {
    id: "salesforce",
    name: "Salesforce",
    short: "SF",
    iconBg: "bg-sky-500",
    description:
      "Sync Salesforce contacts and opportunities with FyrstUp.",
    status: "coming",
  },
];
